import { useCyberStore } from '@entities/tsp'

interface useSelectCountryArgs {
  isSteam: boolean
  showVouchersForm: boolean
}

export const useSelectCountry = ({ isSteam, showVouchersForm }: useSelectCountryArgs) => {
  const { setActiveCountrySteam, setActiveCountry } = useCyberStore()

  const handleCountryClick = (country: string) => {
    if (isSteam && !showVouchersForm) {
      setActiveCountrySteam(country)
    } else {
      setActiveCountry(country)
    }
  }

  return { handleCountryClick }
}
